module.exports = __webpack_public_path__ + "static/media/landing-page.d65b6316.png";